import { createContext } from "react"
import {
    AtribuirFaixasDistanciaInicial,
    AtribuirFaixasDistanciaModel,
    FaixaDistancia,
} from "../models/atribuirFaixasDistanciaModel"
import { AtribuirFaixasDistanciaActionModel } from "./atribuirFaixasDistanciaActions"

type AtribuirFaixasDistanciaContextProps = {
    faixas: AtribuirFaixasDistanciaModel
    dispatch: React.Dispatch<AtribuirFaixasDistanciaActionModel>
    salvar: () => Promise<void>
    removerFaixa: (index: number, faixa: FaixaDistancia) => Promise<void>
    erroCarregamento: string | null
}

const initialContextValue: AtribuirFaixasDistanciaContextProps = {
    faixas: AtribuirFaixasDistanciaInicial,
    dispatch: () => {},
    salvar: async () => {},
    removerFaixa: async () => {},
    erroCarregamento: null,
}

export const AtribuirFaixasDistanciaContext =
    createContext<AtribuirFaixasDistanciaContextProps>(initialContextValue)
